module.exports = __webpack_public_path__ + "img/like.5f21db56.svg";